import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "isUrlInsecure", "value", "id", "onChange"];
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import CheckboxOption from 'components/CheckboxOption';
import Hint from 'components/Hint';
function OpenInNewWindowField(_ref) {
  var isDisabled = _ref.isDisabled,
    isUrlInsecure = _ref.isUrlInsecure,
    value = _ref.value,
    id = _ref.id,
    _onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('property_new_window'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(CheckboxOption, {
    fontSize: "s",
    label: t('actions_open_in_new_window'),
    id: "open-in-new-window",
    checked: !value,
    onChange: function onChange(e) {
      return _onChange(!e.target.checked);
    },
    disabled: isDisabled,
    "aria-describedby": isUrlInsecure ? 'url-insecure-hint' : undefined
  }), isUrlInsecure && /*#__PURE__*/React.createElement(Hint, {
    id: "url-insecure-hint",
    my: "xs"
  }, t('hints_disable_option_for_secure_url')));
}
export default OpenInNewWindowField;